import { useEffect } from 'react'

/**
 * Calls `onOutside` when the user presses the mouse outside `ref` or presses
 * Escape. Listeners are only attached while `enabled` is true, so an idle
 * (closed) popover costs nothing.
 *
 * `onOutside` should be a stable reference (`useCallback` or a state setter),
 * otherwise the listeners are re-attached on every render.
 */
export const useClickOutside = (ref, onOutside, enabled = true) => {
    useEffect(() => {
        if (!enabled) return undefined

        const onMouseDown = (event) => {
            if (ref.current && !ref.current.contains(event.target)) onOutside()
        }
        const onKeyDown = (event) => {
            if (event.key === 'Escape') onOutside()
        }

        document.addEventListener('mousedown', onMouseDown)
        document.addEventListener('keydown', onKeyDown)
        return () => {
            document.removeEventListener('mousedown', onMouseDown)
            document.removeEventListener('keydown', onKeyDown)
        }
    }, [ref, onOutside, enabled])
}

export default useClickOutside
